import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit"
import { hourReportTimerSlice, TimerState } from "./store"
import { AppDispatch, RootState } from "../store"
import { throttle } from "lodash"

const HOUR_REPORT_TIMER_KEY = "hourReportTimer"
const { start, pause, resume, stop, reset, updateStart, hydrate } = hourReportTimerSlice.actions
const channel = typeof BroadcastChannel !== "undefined" ? new BroadcastChannel(HOUR_REPORT_TIMER_KEY) : null

const saveTimer = (timer: TimerState): void => {
  const serializedTimer = JSON.stringify(timer)
  localStorage.setItem(HOUR_REPORT_TIMER_KEY, serializedTimer)
  channel?.postMessage(serializedTimer)
}

const saveTimerThrottled = throttle(saveTimer, 500, { leading: true, trailing: true })

export const loadHourReportTimer = (): TimerState | null => {
  const timerData = localStorage.getItem(HOUR_REPORT_TIMER_KEY)
  if (!timerData) return null
  try {
    return JSON.parse(timerData) as TimerState
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Failed to parse hour report timer from localStorage:", error)
    return null
  }
}

const persistTimerMw = createListenerMiddleware()
persistTimerMw.startListening({
  matcher: isAnyOf(start, pause, resume, stop, reset, updateStart),
  effect: (_, { getState }) => {
    const rootState = getState() as RootState
    const timerState = rootState.hourReportTimer
    saveTimerThrottled(timerState)
  },
})

export const hourReportTimerMiddleware = persistTimerMw.middleware

export const registerCrossTabSync = (dispatch: AppDispatch) => {
  if (!channel) return
  channel.onmessage = (e) => {
    try {
      dispatch(hydrate(JSON.parse(e.data)))
    } catch {
      // eslint-disable-next-line no-console
      console.error("Failed to parse hour report timer data from BroadcastChannel:", e.data)
    }
  }
}
